import constants from '@/app-configs/constants'
import users from './users'
import payments from './payments'
import settings from './settings'
import apitokens from './apitokens'
import apisettings from './apisettings'
import invoicing from './invoicing'

export default [
  {
    title: 'DEBTIA_HOME',
    route: 'home',
    icon: 'HomeIcon',
    action: constants.action.permissionLogin,
    resource: constants.resource.user,
  },
  {
    title: 'DEBTIA_TRANSLATIONS',
    route: 'translations',
    icon: 'GridIcon',
    action: constants.action.permissionTranslationView,
    resource: constants.resource.translation,
    show: true,
  },
  {
    title: 'DEBTIA_ROLE_MANAGEMENT',
    route: 'role-management',
    icon: 'GridIcon',
    action: constants.action.permissionRoleView,
    resource: constants.resource.role,
    show: true,
  },
  ...users,
  ...payments,
  // ...invoices,
  // ...cases,
  ...apitokens,
  ...settings,
  ...apisettings,
  ...invoicing,
]
